import { gql } from '@apollo/client';

export const DELETE_PACKAGE_CLIENT = gql`
  mutation DeletePackageClient($id: Int!) {
    deletePackageClient(id: $id) {
      id
    }
  }
`;

export const CREATE_PACKAGE_CLIENT = gql`
  mutation CreatePackageClient($input: PackageClientInput!) {
    createPackageClient(input: $input) {
      id
      packageId
      clientId
      passport
      client {
        id
        firstName
        lastName
        email
        phone
        agencyId
        agency {
          name
        }
      }
      createdAt
      updatedAt
    }
  }
`; 